/**
 * Article Randomizer
 *
 * This script randomizes the related articles shown at the bottom of blog posts.
 * It shuffles the articles on the client side to ensure true randomization on each page load.
 */

class ArticleRandomizer {
  constructor() {
    this.container = document.querySelector(".article-navigation-container");
    if (!this.container) return;

    this.currentArticleId = this.container.dataset.currentArticleId;
    this.articleCards = Array.from(
      this.container.querySelectorAll(".article-card")
    );

    // Only proceed if we have articles to shuffle
    if (this.articleCards.length > 0) {
      this.shuffleArticles();
    }
  }

  /**
   * Fisher-Yates shuffle algorithm to randomize the articles
   */
  shuffleArticles() {
    // Remove all article cards from the container
    this.articleCards.forEach((card) => card.remove());

    // Shuffle the array
    for (let i = this.articleCards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.articleCards[i], this.articleCards[j]] = [
        this.articleCards[j],
        this.articleCards[i],
      ];
    }

    // Only show up to 3 articles
    const limit = Math.min(3, this.articleCards.length);

    // Add the shuffled cards back to the container
    for (let i = 0; i < limit; i++) {
      this.container.appendChild(this.articleCards[i]);
    }
  }
}

// Initialize the randomizer when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  new ArticleRandomizer();
});

// Also initialize when the document is loaded via Shopify's section rendering
document.addEventListener("shopify:section:load", (event) => {
  if (event.detail.sectionId.includes("main-article")) {
    new ArticleRandomizer();
  }
});

// Handle Shopify theme editor
if (Shopify.designMode) {
  document.addEventListener("shopify:section:select", (event) => {
    if (event.detail.sectionId.includes("main-article")) {
      new ArticleRandomizer();
    }
  });
}
